module.exports = __webpack_public_path__ + "static/media/dr_ewa.5ec8207c.jpg";